import { useNavigate } from "react-router-dom";
import { imgURL } from "./SVGImageUtil";
import { useEffect, useState } from "react";

const FlexThumb = (props) => {

    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [imgSrc, setImgSrc] = useState("");

    const { name, selected, slug, section, hideThumbText = false, thumbBackground = false } = props;

    useEffect(() => {
        if(thumbBackground) {
            const img = new Image();
            img.src = imgURL(thumbBackground);
            console.log("img.src", imgURL(thumbBackground));
            img.onload = () => {
                setImgSrc(imgURL(thumbBackground))
                setLoading(false)
            }
        }
    }, [thumbBackground])

    const thumbBG = {};
    let renderThumbBG = false;
    if (thumbBackground) {
        renderThumbBG = true;
        thumbBG.backgroundImage = `url(${imgSrc})`;
        thumbBG.backgroundPosition = "45% 25%";
        // other properties
    }
    console.log(thumbBG, loading, imgSrc);

    const content = () => {
        if(thumbBackground && loading) {
            return (<div 
            className={`flex_thumb${section?` ${section}`:""}${selected?' active':""}`}>
                <div className="spinnyNiconByrne">
                N&B</div></div>)
        }
        // biome-ignore lint/a11y/useKeyWithClickEvents: <explanation>
        return (<div style={{...thumbBG}} onClick={() => {
            navigate(`/${section}/${slug}`);
        }}
        className={`flex_thumb${section?` ${section}`:""}${selected?' active':""}`}>

        { hideThumbText ? "" : name }
        </div>)
    }

    return (
       <>{content()}</>
    )
}

export default FlexThumb;